import { Component, Input } from '@angular/core';
import { eGENA_Checkliste } from '../../visionet/Checkliste';
import { ChecklistPage } from '../..//pages/checklist/checklist';
import { ChecklistPhonePage } from '../..//pages/checklist/Phone/ChecklistPhonePage';
import { NavController } from 'ionic-angular';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';

@Component({
	selector: 'SuchtrefferListe',
	templateUrl: 'SuchtrefferListe.html'
})
export class SuchtrefferListeComponent {

	text: string;

	@Input()
	itemList :	eGENA_Checkliste[] = [];
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''


	constructor(public navCtrl: NavController, public globals: GlobalsSingleton) {
	}


	/**	=== Visionet(sl) ==========
	 *	Verarbeite den Klick auf eine Checkliste in der Trefferliste.
	 *	Als Parameter erhalten wir die ID einer Checkliste und zu dieser Checkliste soll gewechselt werden
	 */
	openChecklist(checklisteId : number) : void {
		if (this.globals.isPhone()) {
			this.navCtrl.push(ChecklistPhonePage, {
				checklisteId: checklisteId.toString(),
				curPatientType: this.ausgewaehlterPatiententyp,
				curSearchType: this.activeSearch
				},
				{
					animate : true,
					animation: "ios-transition"
				}
			);
		}
		else {
			this.navCtrl.push(ChecklistPage, {
				checklisteId: checklisteId.toString(),
				curPatientType: this.ausgewaehlterPatiententyp,
				curSearchType: this.activeSearch
				},
				{
					animate : true,
					animation: "ios-transition"
				}
			);
		}
	}





	/**	=== Visionet(sl) ==========
	 *
	 *	@param element 
	 */
	istEinfacheCheckliste(element : eGENA_Checkliste) : boolean {
		return element.übergeordnet != true;
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/SuchtrefferListe.ts